import styled from "styled-components";

export const Title = styled.h1`
  text-align: center;
  font-size: 3rem;
  position: relative;
  font-weight: 600;

  margin: 0;
`;

export const Description = styled.h2`
  font-weight: 400;
  width: 100%;
  text-align: center;
  font-size: 2rem;
  margin: 4px;
  position: relative;
`;

export const EsqueciSenha = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-weight: 600;
  font-size: 1.8rem;
  color: #e71037;
  text-decoration: underline;
  padding: 8px;
`;
